import React from "react";
import { Heart } from "lucide-react";

// Renders text where the capital "K" of "Kind" becomes a K-glyph: a vertical stroke
// with a heart hugging it as the arms. e.g. "The Kind Social" -> "The |♥ind Social".
export function KindText({ text = "Kind Social", className = "" }) {
  const idx = text.indexOf("Kind");
  if (idx === -1) return <span className={className}>{text}</span>;
  return (
    <span className={className} data-kind-heart>
      {text.slice(0, idx)}
      <span className="inline-flex items-center align-[-0.14em]" aria-label="K" style={{ height: "0.94em" }}>
        <span className="bg-current inline-block" style={{ width: "0.12em", height: "0.94em", borderRadius: "1.5px" }} />
        <Heart className="fill-current" strokeWidth={2} style={{ width: "0.92em", height: "0.92em", transform: "rotate(90deg)", marginLeft: "-0.11em", color: "#DD2E44" }} />
      </span>
      {text.slice(idx + 1)}
    </span>
  );
}

export default KindText;
